import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { UniversalLearn } from "@/components/universal";

const BankingAwarenessLearnPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isPro = user?.banking_role === "PRO" || user?.role === "PRO";

  return (
    <UniversalLearn
      examType="banking"
      isPro={isPro}
      onBack={() => navigate('/banking')}
      defaultSection="banking_awareness"
      onPractice={(subTopic) => {
        navigate(`/banking/practice`);
      }}
    />
  );
};

export default BankingAwarenessLearnPage;
